import styled from 'styled-components';
import { NumberInput } from '../../baseInputs/NumberInput';
import { useScene } from '../../../../context/sceneContext';

export const GapInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData({ gap: 0 }, 'props.class');

  const updateValue = (key: string, value?: string | number) =>
    scene.updateSelectedElementsData({ [key]: value }, 'props.class', 'gapInput');

  return (
    <Row>
      <NumberInput
        iconClassName="icon-gap"
        id={'gap-input'}
        tooltip="Gap"
        value={data.gap}
        onChange={(newValue) => updateValue('gap', newValue)}
        precision={0}
        minValue={0}
        defaultUnit="px"
        inputStyle={{ textAlign: 'center' }}
      />
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;

  gap: 5px;
`;
